export default [
    {
        path: 'bnafar-relatorio-envio',
        component: () => import(
            /* webpackChunkName: 'integracao-bnafar-relatorio-envio' */
            '@/views/integracao/bnafar/relatorio-envio/Index'
        ),
        redirect: 'bnafar-relatorio-envio/index',
        children: [
            {
                name: 'integracao-bnafar-relatorio-envio-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'integracao-bnafar-relatorio-envio' */
                    '@/views/integracao/bnafar/relatorio-envio/List'
                ),
            },
        ]
    }
]